<template>
  <div>
    <div class="my-input-with-search">
      <el-input
        :placeholder="placeholderTxt"
        v-model.trim="keyWords"
        clearable
        @clear="onClickClear()"
        style="width: 400px"
        @keyup.enter.native="onClickEnter"
        @input="handleInput"
      >
        <template slot="append"
          ><el-button type="primary" @click="onClickSearch"
            >搜索</el-button
          ></template
        >
      </el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholderTxt: {
      type: String,
      default: "请输入",
    },
    modelValue: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      keyWords: "",
    };
  },
  methods: {
    onClickClear() {
      this.$emit("on-clear");
    },
    onClickSearch() {
      this.$emit("on-search", this.keyWords);
    },
    onClickEnter() {
      this.$emit("on-enter", this.keyWords);
    },
    handleInput() {
      this.$emit("input", this.keyWords);
    }
  },
};
</script>
<style lang="less" scoped>
@primaryColor: #409eff;
@lightBgColor: #fff;

.my-input-with-search {
  &_btn {
    display: flex;
    justify-content: flex-end;
    .el-form-item:nth-last-child(1) {
      margin-right: 0;
    }
  }

  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background-color: @primaryColor;
    border-color: @primaryColor;
    color: @lightBgColor;
  }

  /deep/ .el-button {
    height: 40px;
  }
}
</style>
